import { render, staticRenderFns } from "./drugAgentAudit.vue?vue&type=template&id=36367b6b&scoped=true&"
import script from "./drugAgentAudit.vue?vue&type=script&lang=js&"
export * from "./drugAgentAudit.vue?vue&type=script&lang=js&"
import style0 from "./drugAgentAudit.vue?vue&type=style&index=0&id=36367b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36367b6b",
  null
  
)

export default component.exports